import { render } from "./SubMenu1.vue?vue&type=template&id=2c4e3c3c&scoped=true"
import script from "./SubMenu1.vue?vue&type=script&lang=js"
export * from "./SubMenu1.vue?vue&type=script&lang=js"

import "./SubMenu1.vue?vue&type=style&index=0&id=2c4e3c3c&scoped=true&lang=css"
import "./SubMenu1.vue?vue&type=style&index=1&id=2c4e3c3c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4e3c3c"]])

export default __exports__